import React, { Fragment, useEffect } from "react";
import "./researchpaper.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "../../helper/api";
import Loading from "../Loading/Loading";

const ResearchPaper = () => {
	const [publicationData, setPublicationData] = useState(null);
	const [totalNation, setTotalNation] = useState({
		published: 0,
		presented: 0,
	});
	const [totalInternational, setTotalInternational] = useState({
		published: 0,
		presented: 0,
	});
	const [totalOther, setTotalOther] = useState({
		published: 0,
		presented: 0,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadData = async () => {
			try {
				const response = await api({
					method: "post",
					url: "fetch.php",
					data: { get_research_paper: true },
					headers: { "Content-Type": "multipart/form-data" },
				});
				const jsonData = await response.data;
				setPublicationData(jsonData.data);
				setLoading(false);
			} catch (err) {
				setLoading(false);
			}
		};
		loadData();
	}, []);

	useEffect(() => {
		const countOccurrences = (value, obj) => {
			let count = 0;
			Object.values(obj).forEach((item) => {
				console.log(item.level);
				if (item.level === value) {
					count++;
				}
			});
			return count;
		};
		if (publicationData) {
			let internationalCount = {
				published: 0,
				presented: 0,
			};
			let nationalCount = {
				published: 0,
				presented: 0,
			};
			let othersCount = {
				published: 0,
				presented: 0,
			};

			publicationData.forEach((item) => {
				if (item.published) {
					internationalCount.published += item.published
						?.international
						? item.published?.international
						: 0;
					nationalCount.published += item.published?.national
						? item.published?.national
						: 0;
					othersCount.published += item.published?.others
						? item.published?.others
						: 0;
				}
				if (item.presented) {
					internationalCount.presented += item.presented
						?.international
						? item.presented?.international
						: 0;
					nationalCount.presented += item.presented?.national
						? item.presented?.national
						: 0;
					othersCount.presented += item.presented?.others
						? item.presented?.others
						: 0;
				}
			});

			setTotalNation(nationalCount);

			setTotalInternational(internationalCount);

			setTotalOther(othersCount);
		}
	}, [publicationData]);
	return (
		<Fragment>
			{loading && <Loading />}

			<div className="research-paper-container container">
				<div className="research-paper-content">
					<p>
						Research contains "imaginative and deliberate work
						attempted to expand the load of learning, including
						knowledge of humans, culture and society, and the
						utilization of this stock of knowledge to devise new
						applications. It is used to set up or affirm fact,
						reaffirm the consequences of past work, take care of new
						or existing issues, bolster hypotheses, or develop new
						speculations.A research project may also be an expansion
						on past work in the field. Research projects can be used
						to develop further knowledge on a topic.
					</p>
					<p>
						Following are the list of research publications by the
						faculty members and students of GNVS.
					</p>
				</div>
				<div className="research-paper-heading">
					<h4>Paper Presented</h4>
				</div>
				<div className="publication-count-container">
					<div className="publications-international-container">
						<div className="publications-international-count">
							<h5>{totalInternational.presented}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>International</h5>
						</div>
					</div>
					<div className="publications-national-container">
						<div className="publications-national-count">
							<h5>{totalNation.presented}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>National</h5>
						</div>
					</div>
					<div className="publications-other-container">
						<div className="publications-other-count">
							<h5>{totalOther.presented}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>Others</h5>
						</div>
					</div>
				</div>
				<div className="research-paper-published-heading">
					<h4>Paper Published</h4>
				</div>
				<div className="publication-count-container">
					<div className="publications-international-container">
						<div className="publications-international-count">
							<h5>{totalInternational.published}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>International</h5>
						</div>
					</div>
					<div className="publications-national-container">
						<div className="publications-national-count">
							<h5>{totalNation.published}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>National</h5>
						</div>
					</div>
					<div className="publications-other-container">
						<div className="publications-other-count">
							<h5>{totalOther.published}</h5>
						</div>
						<div className="publications-international-heading">
							<h5>Others</h5>
						</div>
					</div>
				</div>
				<div className="research-paper-table-container">
					<table className="research-paper-table">
						<tr>
							<th colspan="1"></th>
							<th colspan="3">Paper Presented</th>
							<th colspan="3">Paper Published</th>
						</tr>
						<tr>
							<th>Year</th>
							<th>International</th>
							<th>National</th>
							<th>Others</th>
							<th>Internationa</th>
							<th>National</th>
							<th>Others</th>
						</tr>
						{publicationData &&
							publicationData.map((item, id) => (
								<tr key={id}>
									<td>
										<Link
											to={`/research-paper/${item.year}`}
										>
											{item.year}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/presented/international`}
										>
											{item.presented?.international !=
											null
												? item.presented?.international
												: 0}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/presented/national`}
										>
											{item.presented?.national != null
												? item.presented.national
												: 0}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/presented/others`}
										>
											{item.presented?.others
												? item.presented?.others
												: 0}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/published/international`}
										>
											{item.published?.international
												? item.published?.international
												: 0}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/published/national`}
										>
											{item.published?.national
												? item.published?.national
												: 0}
										</Link>
									</td>
									<td>
										<Link
											to={`/research-paper/${item.year}/published/others`}
										>
											{item.published?.others
												? item.published?.others
												: 0}
										</Link>
									</td>
								</tr>
							))}
					</table>
				</div>
			</div>
		</Fragment>
	);
};

export default ResearchPaper;
